import {Controller} from "stimulus"
import StimulusReflex from 'stimulus_reflex'

const CODE_LENGTH = 4;

export default class extends Controller {
    static targets = ["form", "code1", "code2", "code3", "code4"];

    inputs = [];
    resetGuessAttempt = false;

    // keyupHandler helps focus onto next input
    keyupHandler = (event) => {
        const currentInput = event.target;
        const {keyCode} = event;

        // Allow: backspace, delete, left arrow
        if ([46, 8, 37].includes((keyCode))) {
            const prevInput = currentInput.previousElementSibling;
            if (prevInput) {
                const val = prevInput.value;
                // move cursor to the end of value
                prevInput.value = '';
                prevInput.focus();
                prevInput.value = val
            }
        } else if (currentInput.value) {
            const nextInput = currentInput.nextElementSibling;
            if (nextInput) {
                nextInput.focus();
                nextInput.value = '';
            } else {
                // all code input filled => trigger changeHandler
                currentInput.blur()
            }
        }
    };

    // changeHandler triggers after keyupHandler and try to submit guess
    changeHandler = () => {
        const code1 = this.code1Target;
        const code2 = this.code2Target;
        const code3 = this.code3Target;
        const code4 = this.code4Target;
        const guess = code1.value + code2.value + code3.value + code4.value;

        if (guess.length === CODE_LENGTH) {
            this.stimulate("Game#check_guess", guess);
            this.resetGuessAttempt = true;
        }
    };

    errorClassHandler = (element) => {
        if (this.resetGuessAttempt) {
            this.stimulate("Game#reset_session_data");
            element.target.value = '';
            this.resetGuessAttempt = false
        }
    };

    connect() {
        StimulusReflex.register(this);
        this.inputs = document.querySelectorAll('.gameboard-form .xinput.xinput-code');
        this.addListeners();
    }

    disconnect() {
        this.removeListenters();
        this.stimulate("Game#reset_session_data");
    }

    addListeners() {
        this.inputs.forEach(el => {
            el.addEventListener('keyup', this.keyupHandler, false);
            el.addEventListener('change', this.changeHandler, false);
            el.addEventListener('focus', this.errorClassHandler, false);
        });
    }

    removeListenters() {
        this.inputs.forEach(el => {
            el.removeEventListener('keyup', this.keyupHandler, false);
            el.removeEventListener('change', this.changeHandler, false);
            el.removeEventListener('focus', this.errorClassHandler, false);
        });
    }
}